<script>
  import Formrow from "../shared/formrow.svelte"
  import Button from "../shared/button.svelte"
  import Alert from "../shared/alert.svelte"
  import {save} from "../shared/api.js"
  import Strength  from "./password-strength.svelte"
  import { slide } from 'svelte/transition';
  let password1 = ""
  let password2 = ""
  let message
  let error
  let disabled = false
  

  const signup = async (e)=>{
    e.preventDefault()
    disabled = true
    if(password1.length < 8){
      error = "Your password is too short, it needs to be 8 letters or more."
      disabled = false
      return
    }
    if(password1!=password2){
      error = "Your passwords don't match"
      disabled = false
      return
    }
    try{
      let user = {password:password1}
      let res = (await save({ url:"/duocms/api/users/me", method:"POST", data:user })).data
      message = res.message || "Your password has been updated successfully."
      password1 = ""
      password2 = ""
      disabled = false
    }catch(err){
      // let toaster show error
    }
  }
</script>

<form on:submit={signup} >
  <Formrow name="password1" type="password" label="Password" bind:value={password1} required autocomplete="new-password" on:focus={(e)=> error=""} />
  <Formrow name="password2" type="password" label="Repeat Password" bind:value={password2} required autocomplete="new-password" on:focus={(e)=> error=""} />
  <div style="margin:0 5px 0 170px;">
    <Strength password={password1} />
    <br>
    {#if message}
      <Alert mode="info" close on:closed={()=> message = ""}>{message}</Alert>
    {/if}
    {#if error}
      <Alert mode="danger" close on:closed={()=> error = ""}>{error}</Alert>
    {/if}
    
    <Button mode="primary" type="submit" {disabled}>Reset Password</Button>
  </div>
</form>